import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListItem } from '../models/lists.model';
import { GenericListService } from './lists.service';

export enum ZSNListType {
  ZSN_RESULT_TYPES,
  ZSN_CONSOLE_MODULATION_TYPES,
}

@Injectable({ providedIn: 'root' })
export class ZSNListsService extends GenericListService<ZSNListType> {
  constructor(http: HttpClient) {
    super(http);
    this.listsUrl = '/tools/zsn/lists';
  }

  handleResponse(response: any) {
    const data = response.data;
    const converted = new Map<ZSNListType, ListItem[]>();
    for (const d in data) {
      const listType: ZSNListType = <any>ZSNListType[<any>d];
      const value = data[d];
      const typeData = value.map(this.extractI18n);
      converted.set(listType, typeData);
      this.cache.set(listType, typeData);
    }
    return converted;
  }
}
